import { useState, useEffect } from '@max/max';
const isWeb = true;
import { getScreenSize } from '@max/meituan-uni-screenInfo';
export function useWindowSize() {
    const screenSize = getScreenSize();
    const [size, setSize] = useState({
        width: screenSize.width,
        height: screenSize.height
    });
    useEffect(() => {
        if (true) {
            const updateSize = () => setSize({
                width: screenSize.width,
                height: screenSize.height
            });
            window.addEventListener('resize', updateSize);
            return () => window.removeEventListener('resize', updateSize);
        }
    }, [size]);
    return size;
}
